import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import Loader from '../../components/Loader/Loader';
import * as cms from '../../shared/repos/cms/cms';
import cmsKeys from '../../shared/constants/cms';
import { getKeyValue } from '../../shared/utilities/cms';

import styles from './TermsAndConditions.module.css';
import CmsInlineEdit from '../../components/Cms/CmsInlineEdit';
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';
import SecondaryPageEmpty from '../SecondaryPages/SecondaryPageEmpty';
import SnackMadnessTermsContent from './SnackMadnessTermsContent';

const SNACK_MADNESS_TERMS_PAGE_TITLE = 'Sweepstakes Terms and Conditions | Insomnia Cookies';

const STATIC_TERMS_PAGES = {
  'snack-madness-sweeps': {
    title: SNACK_MADNESS_TERMS_PAGE_TITLE,
    Content: SnackMadnessTermsContent,
  },
};

class TermsAndConditions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      content: [],
    };
  }

  componentDidMount() {
    const { path } = this.props;
    const staticPage = STATIC_TERMS_PAGES[path];
    // Static pages skip CMS; each terms route should use a stable key so this runs on mount only
    if (staticPage) {
      document.title = staticPage.title;
      this.setState({ loading: false, content: [] });
      return;
    }
    cms.getContent(this.getCmsKeyForPath(), this);
  }

  /** CMS keys by path — cookielab, dream-dorm, and birthday giveaway use dedicated pages; snack-madness is static. */
  getCmsKeyForPath() {
    const { path } = this.props;
    if (path === 'cookielab') return [cmsKeys.eventTermsConditionsPage];
    if (path === 'dream-dorm-room-giveaway') return [cmsKeys.dreamDormGiveawayTermsPage];
    if (path === 'insomnia-23rd-birthday-terms-and-conditions') {
      return [cmsKeys.insomnia23rdBirthdayGiveawayTermsPage];
    }
    return [cmsKeys.termsConditionsPage];
  }

  render() {
    const SectionHeading = isBrandRefreshEnabled() ? 'h2' : 'h3';
    const { content, loading } = this.state;
    const { path } = this.props;

    if (loading) {
      return (
        <div className={styles.pageWrapper} data-region="secondary-page" data-page="TermsAndConditions" data-terms-path={path}>
          <div className={styles.pageContainer} data-part="content-surface">
            <Loader id="loader" />
          </div>
        </div>
      );
    }

    const staticPage = STATIC_TERMS_PAGES[path];
    if (!content.length && staticPage) {
      const { Content } = staticPage;
      return (
        <div className={styles.pageWrapper} data-region="secondary-page" data-page="TermsAndConditions" data-terms-path={path}>
          <Content />
        </div>
      );
    }

    if (!content.length) {
      return (
        <div className={styles.pageWrapper} data-region="secondary-page" data-page="TermsAndConditions" data-terms-path={path}>
          <div className={`${styles.pageContainer} text-dark dark:text-white`} data-part="content-surface">
            {isBrandRefreshEnabled() ? <SecondaryPageEmpty /> : <h1>Oops, No data found for this page</h1>}
          </div>
        </div>
      );
    }

    return (
      <div className={styles.pageWrapper} data-region="secondary-page" data-page="TermsAndConditions" data-terms-path={path}>
        <div className={`${styles.pageContainer} text-dark dark:text-white`} data-part="content-surface">
          {content.map((termsConditionsPage) => {
            const sections = getKeyValue(termsConditionsPage.children, 'sections', true);
            const mainTitle = _.find(termsConditionsPage.children, { key: 'title' });
            const subTitle = _.find(termsConditionsPage.children, { key: 'subtitle' });
            const mainBody = _.find(termsConditionsPage.children, { key: 'body' });
            return (
              <div key={termsConditionsPage.key || 'terms'}>
                <div className={styles.pageSection} data-part="prose-section">
                  <h1>
                    <CmsInlineEdit cmsNode={mainTitle}>{mainTitle?.value}</CmsInlineEdit>
                  </h1>
                  {subTitle?.value && (
                    <p>
                      <CmsInlineEdit cmsNode={subTitle}>{subTitle.value}</CmsInlineEdit>
                    </p>
                  )}
                  <p>
                    <CmsInlineEdit cmsNode={mainBody}>{mainBody?.value}</CmsInlineEdit>
                  </p>
                </div>

                {sections &&
                  sections.children.map((termsConditionsSection) => {
                    const header = _.find(termsConditionsSection.children, { key: 'header' });
                    const body = _.find(termsConditionsSection.children, { key: 'body' });
                    return (
                      <div key={termsConditionsSection.key || header?.value}>
                        {termsConditionsSection.children.length > 0 ? (
                          <div className={styles.pageSection} data-part="prose-section">
                            <SectionHeading>
                              <CmsInlineEdit cmsNode={header}>{header?.value}</CmsInlineEdit>
                            </SectionHeading>
                            <p>
                              <CmsInlineEdit cmsNode={body}>{body?.value}</CmsInlineEdit>
                            </p>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    );
                  })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

TermsAndConditions.defaultProps = {
  path: 'terms',
};

TermsAndConditions.propTypes = {
  path: PropTypes.string,
};

export default TermsAndConditions;
